import { Box, Center } from '@/src/packages/components';
import { tv } from 'tailwind-variants';
import { IProductSelectedOptions } from '@/src/packages/components/pages/Product/ProductContext';
import { IFetchProductVariantSchema } from '@bitmap/contracts';
import { ProductOptionValue } from '@prisma/client';

const productSizeSelectorStyles = tv({
  base: 'h-10 leading-none transition cursor-pointer flex-1 text-sm border-r last:border-r-0',
  variants: {
    isSelected: {
      true: 'bg-background-secondary',
    },
  },
  compoundVariants: [
    {
      isSelected: false,
      className: 'hover:bg-background-secondary',
    },
  ],
});

export const ProductSizeSelector = ({
  option,
  skus,
  selectedOptions,
  handleSelectOption,
}: {
  skus: IFetchProductVariantSchema['skus'];
  selectedOptions: IProductSelectedOptions;
  handleSelectOption(
    option: IFetchProductVariantSchema['product']['options'][0],
    value: ProductOptionValue,
  ): void;
  option: IFetchProductVariantSchema['product']['options'][0];
}) => {
  const sizeOptions = option.values;

  return (
    <Box className="flex overflow-hidden border" borderRadius="default">
      {sizeOptions.map((size) => {
        const opt = selectedOptions.find((o) => o.optionId === option.id);

        const isSelected = opt?.value === size.id;

        return (
          <Box
            as="button"
            key={size.id}
            className={productSizeSelectorStyles({
              isSelected,
            })}
            onClick={() => handleSelectOption(option, size)}
          >
            <Center>{size.name}</Center>
          </Box>
        );
      })}
    </Box>
  );
};
